import type { AxiosInstance } from 'axios';
import { normalizeEmail } from '../utils/libs';

export type OwnerLoginResponse = {
  status: number;
  data?: any;
  accessToken?: string;
  refreshToken?: string;
  location?: any;
  message?: string;
};

export type OwnerRefreshResponse = {
  status: number;
  accessToken?: string;
  refreshToken?: string;
  message?: string;
};

// Owner login with email/username + password (mirrors web Login.jsx)
export const ownerLoginCore = async (
  axiosinstance: AxiosInstance,
  payload: {
    bp_password: string;
    bp_email_address?: string;
    bp_username?: string;
  },
) => {
  return axiosinstance.post(
    '/bp_owner_login_information',
    JSON.stringify(payload),
  );
};

export const ownerLogin = async (
  axiosinstance: AxiosInstance,
  emailOrUsername: string,
  password: string,
): Promise<OwnerLoginResponse> => {
  try {
    const isEmail = emailOrUsername.includes('@');
    const payload: any = { bp_password: password };
    if (isEmail) payload.bp_email_address = normalizeEmail(emailOrUsername);
    else payload.bp_username = emailOrUsername.trim();
    const res = await ownerLoginCore(axiosinstance, payload);
    return res?.data ?? { status: res?.status };
  } catch (e: any) {
    return Promise.reject(e);
  }
};

// Owner token refresh using refresh token. Mirrors employee refresh endpoint signature
export const ownerRefreshTokenCore = async (
  axiosinstance: AxiosInstance,
  refreshToken: string,
) => {
  return axiosinstance.post(
    `/bp_refresh_token_information/${refreshToken}`,
    {},
  );
};

export const ownerRefreshToken = async (
  axiosinstance: AxiosInstance,
  refreshToken: string,
): Promise<OwnerRefreshResponse> => {
  try {
    const res = await ownerRefreshTokenCore(axiosinstance, refreshToken);
    return res?.data ?? { status: res?.status };
  } catch (e: any) {
    return Promise.reject(e);
  }
};
